import React, { PureComponent, PropTypes } from 'react';
import { Button } from 'react-fast-ui';
import RecruitPhoto from './RecruitPhoto';
import ShortRecruitDetails from './ShortRecruitDetails';
import { firstInitialLastName } from '../filters/RecruitFilters';
import { colors } from '../util/constants';

const FOOTER_STYLE = { backgroundColor: colors.HIGHLIGHT_COLOR };
const FOOTER_CLASSES = 'border-top-style-solid border-top-color-lightest-gray border-top-width-1px';

// add event icon
const ADD_EVENT_ICON = 'calendar-plus-o';

// has scheduled event icon
const HAS_EVENT_ICON = 'calendar-check-o';

export default class ShortRecruitDetailsWithPhotoAndMore extends PureComponent {
  static propTypes = {
    hasEvent: PropTypes.bool,
    onClickName: PropTypes.func,
    onScheduleEvent: PropTypes.func,
    recruit: PropTypes.object.isRequired
  };

  static defaultProps = {
    onClickName: null,
    onScheduleEvent: null,
    hasEvent: false
  };

  render() {
    const { hasEvent, onClickName, onScheduleEvent, recruit, ...rest } = this.props;

    let footer = null;
    if (onScheduleEvent) {
      footer = (
        <div className={FOOTER_CLASSES} style={FOOTER_STYLE}>
          <Button
            className="text-nowrap"
            borderless={true}
            icon={hasEvent ? HAS_EVENT_ICON : ADD_EVENT_ICON}
            onClick={() => onScheduleEvent(recruit)}
            text={`${hasEvent ? 'Event Scheduled' : 'Schedule Event'} with ${firstInitialLastName(recruit)}`}
            type={hasEvent ? 'success' : 'primary'}
          />
        </div>
      );
    }

    return (
      <div {...rest}>
        <div className="display-flex pd-top-md pd-left-md pd-right-md pd-bottom-md overflow-hidden">
          <RecruitPhoto className="flex-shrink-0" expandable={false} value={recruit.photo ? recruit.photo.url : null}/>
          <ShortRecruitDetails
            className="flex-grow-1 flex-shrink-1 mg-left-md"
            onClickName={onClickName}
            recruit={recruit}
          />
        </div>
        {footer}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/ShortRecruitDetailsWithPhotoAndMore.jsx